export default {
      id: "dualArrows-usage",
      viewBox: "0 0 20 18",
      url: __webpack_public_path__ + "sprite.1792148661250.svg#dualArrows-usage",
      toString: function () {
        return this.url;
      }
    }